import {notificationService} from "../../common/api.service";

const initialStates = {
    status: 'loading',
    form_data: {
        user_id: '',
        email_verified_at: false,
        send_change_password: '',
        send_ticket_reply: '',
        send_terminal_change_status: '',
        send_successful_transaction: '',
        // send_checkout: ''
    },
    telegramData: {
        user_id: '',
        send_change_password: '',
        send_ticket_reply: '',
        send_terminal_change_status: '',
        send_successful_transaction: '',
        send_login_system_success: '',
        send_wallet_settlement_success: '',
        bot_id: null
        // send_checkout: ''
    },
}

const mutations = {
    loading(state) {
        state.status    = 'loading'
    },
    success(state, form_data) {
        state.status    = 'success'
        state.form_data = form_data
    },
    telegramSuccess(state, form_data) {
        state.status    = 'success'
        state.telegramData = form_data
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    telegramData: ({telegramData}) => telegramData
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return notificationService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },

    fetchTelegramNotification({commit}) {
        commit('loading')
        return notificationService.fetchTelegramNotification().then(response => {
            commit('telegramSuccess', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}